"use client"

import { ArrowLeft } from "lucide-react"
import { useRouter } from "next/navigation"

import { Button } from "./ui/button"

export default function GoBackButton() {
  const router = useRouter()
  return (
    <Button
      onClick={() => {
        router.push("/boilerplates")
      }}
      variant="secondary"
      className="flex !w-fit gap-2"
    >
      <ArrowLeft />
      <span>Go back</span>
    </Button>
  )
}
